export const getArrayOfEntries = (props) => {
  const keys = [
    'blog',
    'callToAction',
    'componentCollection',
    'image',
    'inlineMarketingForm',
    'podcast',
    'richText',
    'section',
    'taxonomies',
    'webinar',
    'wistiaVideo',
    'embedCode',
    'query',
  ];

  const entries = keys
    .filter((key) => props[key])
    .map((key) => props[key])
    .flat();

  return entries;
};

export const getEntry = (id, entries, componentMap) => {
  if (componentMap) {
    const matchedId = componentMap
      .map((mapItem) => mapItem?.split(':'))
      .find(([templateId]) => templateId === id)?.[1]
      ?.trim();

    return entries?.find((entry) => entry.contentful_id === matchedId);
  }

  return entries?.find((entry) => entry.templateId === id);
};

export const getEntries = (id, entries) =>
  entries?.filter((entry) => entry.templateId.includes(id));

export const getRichTextValue = (entry) =>
  JSON.parse(entry.content.raw)?.content?.[0]?.content?.[0]?.value;

export const flattenEntries = (arr) => {
  return arr.reduce((flat, toFlatten) => {
    return flat.concat(
      Array.isArray(toFlatten.columns || toFlatten.items)
        ? flattenEntries(toFlatten.columns || toFlatten.items)
        : toFlatten,
    );
  }, []);
};
